import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../../../constants/routes'

import MuiBox from '@mui/material/Box'
import MuiIconButton from '@mui/material/IconButton'
import MuiTypography from '@mui/material/Typography'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import LoadingScreen from '../../../../components/loading-screen'
import CampaignList from './components/campaignList'
import { useGetCampaignsForClientQuery } from '../../../campaigns/slice'

const Campaigns = ({ client }) => {
  const navigate = useNavigate()
  const { data: campaigns, isLoading: isCampaignsLoading } = useGetCampaignsForClientQuery(client?.id)

  if (isCampaignsLoading) return <LoadingScreen width="100%" heigh="100px" />

  return (
    <>
      <MuiBox sx={{ display: 'flex', alignItems: 'center' }}>
        <MuiTypography variant="h6">CAMPAIGNS</MuiTypography>
        {client?.id && (
          <MuiIconButton onClick={() => navigate(`${ROUTES.CAMPAIGNS}/new`)}>
            <AddCircleOutlineIcon />
          </MuiIconButton>
        )}
      </MuiBox>
      {!client?.id && <MuiTypography>You will be able to add campaigns after you save this client.</MuiTypography>}
      {campaigns?.length > 0 && <CampaignList client={client} />}
      {client?.id && !campaigns?.length && <MuiTypography>No campaigns have been added for this client.</MuiTypography>}
    </>
  )
}

export default Campaigns
